import {Component, Input, OnInit} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {StocksService} from "../../core/services/gestion-stock/stocks.service";
import {AccordionInventaireService} from "../../core/services/gestion-stock/accordion-inventaire.service";
import {ButtonThemeEnum} from "../../shared/ui/button/button-theme-enum";

@Component({
  selector: 'yo-tab-menu',
  templateUrl: './tab-menu.component.html',
  styleUrls: ['./tab-menu.component.scss'],
  standalone: false
})
export class TabMenuComponent implements OnInit {

  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @Input() tabs: MenuItem[] = [];
  @Input() selectedTab: MenuItem;

  readonly printableLabels: string[] = ['Inventaire', 'Mouvements'];

  constructor(
    public stockSvc: StocksService,
    private accordionInventaireSvc: AccordionInventaireService
  ) { }

  expendAccordion() {
    this.accordionInventaireSvc.triggerExpandAll();
  }

  collapseAccordion() {
    this.accordionInventaireSvc.triggerCollapseAll();
  }

  ngOnInit() {
  }

  isSelected(tab: MenuItem): boolean {
    return this.selectedTab == tab;
  }

  isPrintable(): boolean {
    return this.selectedTab?.label.includes(this.printableLabels.find(label => this.selectedTab.label === label));
  }

  isOnInventaire(): boolean {
    return this.selectedTab?.label.includes(this.printableLabels.find(_ => this.selectedTab.label === 'Inventaire'));
  }

  isOnHistoriqueInventaire(): boolean {
    return this.selectedTab?.label === 'Historique inventaire';
  }
}
